module.exports = __webpack_public_path__ + "static/media/regiobank.e79a6f9d.png";